import { useState } from "react";
import { ListItem, Typography, Box, List, Collapse } from "@mui/material";
import InvestmentChildrenGroup from "./InvestmentChildrenGroup";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { useTheme } from "@emotion/react";

export default function InvestmentTypeGroup({ group, period }) {
	const userCurrency = localStorage.getItem("userCurrency");
	const [isExpanded, setIsExpanded] = useState(true);

	const theme = useTheme();

	const { totalBudget, totalTransactionsSum } = group;

	const balanceStyles = {
		color:
			totalTransactionsSum >= totalBudget
				? theme.palette.values.positive
				: theme.palette.values.negative,
	};

	return (
		<>
			<List sx={{ pl: 0.4, py: 0 }}>
				<ListItem
					sx={{
						pb: 0,
						display: "flex",
						alignItems: "center",
						justifyContent: "space-between",
					}}
				>
					<Box sx={{ display: "flex", alignItems: "center" }}>
						<Typography variant="subtitle1" fontWeight="bold">
							{group.type === "investment"
								? "🏠Assets"
								: "🧾Liabilities"}
						</Typography>
						{group.wallets.length !== 0 &&
							(isExpanded ? (
								<ExpandLess
									sx={{ cursor: "pointer" }}
									onClick={() => setIsExpanded(!isExpanded)}
								/>
							) : (
								<ExpandMore
									sx={{ cursor: "pointer" }}
									onClick={() => setIsExpanded(!isExpanded)}
								/>
							))}
					</Box>
					<Box sx={{ display: "flex" }}>
						<Typography
							variant="body1"
							sx={{
								fontWeight: "bold",
								...balanceStyles,
							}}
						>
							{totalTransactionsSum.toFixed(2).toLocaleString()}{" "}
							{userCurrency}
						</Typography>
						<Typography
							variant="body1"
							sx={{
								mx: 0.5,
								fontWeight: "bold",
							}}
						>
							{"/"}
						</Typography>

						<Typography
							variant="body1"
							sx={{
								fontWeight: "bold",
							}}
						>
							{Math.abs(totalBudget).toFixed(2).toLocaleString()}{" "}
							{userCurrency}
						</Typography>
					</Box>
				</ListItem>
				<Collapse in={isExpanded}>
					<InvestmentChildrenGroup
						type={group.type}
						wallets={group.wallets}
						period={period}
					/>
				</Collapse>
			</List>
		</>
	);
}
